import {doGet, doPost} from './Base';


const getDomains = async () => {
    return await doGet('/linkoln_domains');
};


const reserveDomain = async (domain, subdomain) => {
    return await doPost('/reserve_subdomain', {
        "domain": domain,
        "subdomain": subdomain
    });
};


const releaseDomain = async (domain, subdomain) => {
    return await doPost('/release_subdomain', {
        "domain": domain,
        "subdomain": subdomain
    });
};


const setDefaultDomain = async (domain, subdomain) => {
	let full_domain = domain + '.' + subdomain;
    return await doPost('/domains/'+full_domain+'/default', {});
};


export {getDomains, reserveDomain, releaseDomain, setDefaultDomain};
export default getDomains;
